
import { Component, Vue } from 'vue-property-decorator';
import JoeyLoading from './JoeyLoading.vue';

@Component({
    components: {
        JoeyLoading
    }
})
export default class InfiniteScroll extends Vue {
    private margin: number = 200;
    private isLoading: boolean = false;
    created() {
        window.addEventListener('scroll', () => {
            const scrollTop =
                window.scrollY ||
                window.pageYOffset ||
                window.document.documentElement.scrollTop ||
                window.document.body.scrollTop; // For the sake of compatibility
            const windowHeight = window.outerHeight || window.innerHeight; // For the sake of compatibility
            if (windowHeight + scrollTop + this.margin >= this.$el.scrollHeight) {
                this.isLoading = true;
                this.$emit('loadMore', () => (this.isLoading = false));
            }
        });
    }
}
